
import { Participant } from "@/api/dtos";
import useParticipants from "@/hooks/data/useParticipants";
import useSourceData from "@/hooks/data/useSourceData";
import { createContext } from "react"

export interface ISourceDataContext extends ReturnType<typeof useSourceData> {
}

export const SourceDataContext = createContext<ISourceDataContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default SourceDataContext;